import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="workers--worker"
export default class extends Controller {
  static targets = [
    "workTechTbody", 
    "workTechTemplate",
    "workerRow"
  ]

  addNewWorkTech() {
    const clone = this.workTechTemplateTarget.content.cloneNode(true)
    this.workTechTbodyTarget.appendChild(clone);
  }

  removeWorkTech(event) {
    const button = event.currentTarget;
    const row = button.closest("tr");
    if (row) {
      row.remove();
    }
  }

  select(event) {
    const row = event.currentTarget
    const url = row.dataset.workerUrl
    if (!url) return

    this.workerRowTargets.forEach(r => r.classList.remove("selected"))
    row.classList.add("selected")

    Turbo.visit(url, { frame: "worker_form" })
  }

  new() {
    this.workerRowTargets.forEach(r => r.classList.remove("selected"))
  }
}
